import gql from 'graphql-tag';

export default gql`
mutation createReport($obj: AddReportInput!) {
  addReport(object: $obj) {
    report_id
  }
}
`;
